export default __webpack_public_path__ + "static/media/avatar7.dd232348.svg";